import React, { useEffect, useState } from "react";
import { useSchoolTeacherContext } from "../contexts/SchoolTeacherContext";

const ProfileModal = ({ open, onClose }) => {
        const { teacherData, updateTeacher } = useSchoolTeacherContext();
        const [tab, setTab] = useState("profile");

        const [draft, setDraft] = useState({
                firstName: "",
                lastName: "",
                position: "",
                school: { name: "", type: "", postcode: "" },
        })

        // Close on Escape key
        useEffect(() => {
                function handleKey(e) {
                        if (e.key === "Escape") onClose?.();
                }
                if (open) window.addEventListener("keydown", handleKey);
                return () => window.removeEventListener("keydown", handleKey);
        }, [open, onClose]);

        useEffect(() => {
                if (!open || !teacherData) return;
                setDraft({
                        firstName: teacherData.firstName || "",
                        lastName: teacherData.lastName || "",
                        position: teacherData.position || "",
                        school: {
                                name: teacherData.school?.name || "",
                                type: teacherData.school?.type || "",
                                postcode: teacherData.school?.postcode || "",
                        },
                });
        }, [open, teacherData, tab]);

        if (!open) return null;

        const handleUpdate = () => {
                updateTeacher(draft);
                onClose?.();
        };

        return (
                <div className="modal-overlay" onClick={onClose}>
                        <div
                                className="profile-modal"
                                onClick={(e) => e.stopPropagation()}
                                role="dialog"
                                aria-modal="true"
                                aria-labelledby="modal-title"
                        >
                                {/* Left profile-rail */}
                                <aside className="profile-rail">
                                        <h2 className="profile-rail-title">Settings</h2>
                                        <nav className="profile-rail-nav">
                                                <button className={`profile-nav-item ${tab === "profile" ? "active" : ""}`} onClick={() => setTab("profile")}>Profile details</button>
                                                <button className={`profile-nav-item ${tab === "school" ? "active" : ""}`} onClick={() => setTab("school")}>School settings</button>
                                        </nav>
                                </aside>

                                {/* Main content */}
                                <main className="settings-content">
                                        <h1 id="modal-title" className="settings-content-title">{tab === "school" ? "School settings" : "Profile details"}</h1>

                                        {tab === "school" ? (
                                                <>
                                                        <section className="profile-input-card" tabIndex="0">
                                                                <label className="settings-input-label">School name</label>
                                                                <input className="settings-input" type="text" value={draft.school.name} spellCheck="false" onChange={(e) => setDraft(prev => ({ ...prev, school: { ...prev.school, name: e.target.value } }))} />
                                                        </section>
                                                        <div className="settings-input-hint">ⓘ Your school's name will be displayed on all certificates.</div>

                                                        <section className="profile-input-card" tabIndex="1">
                                                                <label className="settings-input-label">School type</label>
                                                                <select className="settings-input settings-input-select" value={draft.school.type} onChange={(e) => setDraft(prev => ({ ...prev, school: { ...prev.school, type: e.target.value } }))}>
                                                                        <optgroup label="State schools & colleges">
                                                                                <option value="state_secondary">State Secondary (non-selective)</option>
                                                                                <option value="grammar_school">Grammar School (selective)</option>
                                                                                <option value="sixth_form_school">Sixth Form (school-based)</option>
                                                                                <option value="sixth_form_college">Sixth Form College (state)</option>
                                                                                <option value="fe_college">FE College (state, includes 16–19)</option>
                                                                        </optgroup>

                                                                        <optgroup label="Independent schools & colleges">
                                                                                <option value="independent_secondary">Independent Secondary</option>
                                                                                <option value="independent_sixth_form_college">Independent Sixth Form College</option>
                                                                        </optgroup>

                                                                        <optgroup label="Special & alternative provision">
                                                                                <option value="special_school">Special School (KS4/KS5)</option>
                                                                                <option value="ap_pru">Alternative Provision / PRU (KS4/KS5)</option>
                                                                        </optgroup>

                                                                        <optgroup label="Other">
                                                                                <option value="other_education">Other Education (charity, youth org, STEM hub)</option>
                                                                        </optgroup>
                                                                </select>
                                                        </section>

                                                        <section className="profile-input-card" tabIndex="2">
                                                                <label className="settings-input-label">Postcode</label>
                                                                <input className="settings-input" type="text" value={draft.school.postcode} spellCheck="false" onChange={(e) => setDraft(prev => ({ ...prev, school: { ...prev.school, postcode: e.target.value } }))} />
                                                        </section>
                                                        <div className="settings-save-btn" onClick={handleUpdate}>Save Changes</div>
                                                </>
                                        ) : (
                                                <>
                                                        <section className="profile-input-card" tabIndex="0">
                                                                <label className="settings-input-label">First name</label>
                                                                <input className="settings-input" type="text" value={draft.firstName} spellCheck="false" onChange={(e) => setDraft(prev => ({ ...prev, firstName: e.target.value }))} />
                                                        </section>

                                                        <section className="profile-input-card" tabIndex="1">
                                                                <label className="settings-input-label">Last name</label>
                                                                <input className="settings-input" type="text" value={draft.lastName} spellCheck="false" onChange={(e) => setDraft(prev => ({ ...prev, lastName: e.target.value }))} />
                                                        </section>

                                                        <section className="profile-input-card" tabIndex="2">
                                                                <label className="settings-input-label">Position</label>
                                                                <input className="settings-input" type="text" value={draft.position} spellCheck="false" onChange={(e) => setDraft(prev => ({ ...prev, position: e.target.value }))} />
                                                        </section>
                                                        <div className="settings-save-btn" onClick={handleUpdate}>Save Changes</div>
                                                </>
                                        )}
                                </main>

                                <button className="settings-close" onClick={onClose} aria-label="Close">✕</button>
                        </div>
                </div>
        );
}

export default ProfileModal;